<style scoped>
@import '../../assets/css/home.css';
</style>

<template>
<div>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <div class="row home-center">
                    <div class="col-lg-3 col-md-6 col-sm-6 pointer">
                        <div class="card card-stats">
                            <div class="card-header card-header-warning card-header-icon">
                                <div class="card-icon">
                                    <i class="dripicons-user"></i>
                                </div>
                                <p class="card-category">{{$t('home.table_total_member')}}</p>
                                <h4 class="card-title">{{home.user_number}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 pointer">
                        <div class="card card-stats">
                            <div class="card-header card-header-success card-header-icon">
                                <div class="card-icon">
                                    <i class="dripicons-graph-pie"></i>
                                </div>
                                <p class="card-category">{{$t('admin.table_total_trust_in')}}</p>
                                <h4 class="card-title">{{home.total_trust_in}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 pointer">
                        <div class="card card-stats">
                            <div class="card-header card-header-danger card-header-icon">
                                <div class="card-icon">
                                    <i class="dripicons-ticket"></i>
                                </div>
                                <p class="card-category">{{$t('home.table_sms_credit')}}</p>
                                <h4 class="card-title">RM {{home.sms_credit}}</h4>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-3 col-md-6 col-sm-6 pointer">
                        <div class="card card-stats">
                            <div class="card-header card-header-info card-header-icon">
                                <div class="card-icon">
                                    <i class="dripicons-wallet"></i>
                                </div>
                                <p class="card-category">{{$t('home.table_total_wallet')}}</p>
                                <h4 class="card-title">{{home.wallet_number}}</h4>
                            </div>
                        </div>
                    </div> -->
                </div>

                <b-row>
                    <b-col lg="6" md="12">
                        <b-card :header="$t('home.table_wallet_list')" header-tag="header">
                            <!-- <el-table class="custom-table" :data="home.wallet_list" border>
                                <el-table-column v-for="title in walletList" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width"></el-table-column>
                            </el-table> -->
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>{{$t('home.table_id')}}</th>
                                        <th>{{$t('home.table_wallet_list')}}</th>
                                        <th v-if="home.wallet_list[0].balance">{{$t('admin.table_total_amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(content,index) in home.wallet_list" :key="index">
                                        <td>{{content.id}}</td>
                                        <td>{{content.remark}}</td>
                                        <td v-if="content.balance">{{content.balance}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card>
                    </b-col>
                    <!-- <b-col lg="6" md="12">
                        <b-card :header="$t('home.table_package_list')" header-tag="header">
                            <el-table class="custom-table" :data="home.package_list" border>
                                <el-table-column v-for="title in packageList" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width"></el-table-column>
                            </el-table>
                        </b-card>
                    </b-col> -->
                </b-row>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {home} from '@/system/model/home';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{
            home:'',
            walletList:[{
                prop: "id",
                label: this.$t('home.table_id')
            },{
                prop: "remark",
                label: this.$t('home.table_wallet_list')
            }],
            packageList:[{
                prop: "id",
                label: this.$t('home.table_id')
            },{
                prop: "name",
                label: this.$t('home.table_name')
            }],
        }
    },methods:{
        initialize(){
            var self = this;
            var result = home();
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.home = value.data;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
